import { ClientSideComponent } from '@crehana/web';
import { useMediaQuery } from '@crehana/react-hooks';

import CompaniesLogosMobile from './Mobile';
import CompaniesLogosDesktop from './Desktop';
import { CompaniesLogosProps } from './types';

const CompaniesLogos: React.FC<CompaniesLogosProps> = props => {
  const { matches: isMd } = useMediaQuery('md');
  if (isMd) {
    return <CompaniesLogosDesktop {...props} />;
  } else {
    return <CompaniesLogosMobile {...props} />;
  }
};

const WhyCrehnaClientSide: React.FC<CompaniesLogosProps> = props => {
  return (
    <ClientSideComponent>
      <CompaniesLogos {...props} />
    </ClientSideComponent>
  );
};

export default WhyCrehnaClientSide;
